import React, { useState } from 'react';
import PropTypes from 'prop-types';
import HelpIcon from '@material-ui/icons/Help';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Button from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Button';
import Dialog from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import Slide from '@mui/material/Slide';
import useMobileLayout from 'Hooks/useMobileLayout';
import classNames from 'classnames';


const styles = theme => ({
  root: {
  },
  label: {
    color: theme.palette.facet.mediumDarkGray,
    fontSize: theme.typography.fontSize1Rem,
    fontWeight: theme.typography.fontWeightBold,
  },
  overlayContent: {
    padding: 0,
    marginBottom: theme.spacing(5),
    marginLeft: theme.spacing(6.5),
    marginRight: theme.spacing(6.5),
  },
  overlayContentMobile: {
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
  },
  overlayContentTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: theme.palette.primary.main,
    marginTop: theme.spacing(6.5),
    marginBottom: theme.spacing(5),
    marginLeft: theme.spacing(6.5),
    marginRight: theme.spacing(6.5),
  },
  overlayContentTitleMobile: {
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
  },
  overlayContentTitleText: {
    fontSize: 18,
  },
  overlayCloseButton: {
    right: -theme.spacing(2),
  },
});

const Transition = React.forwardRef((props, ref) => {
  return <Slide direction="up" ref={ref} {...props} />;
});

function MoreInfoOverlay({
  title = '',
  label = '',
  overlayContent,
  classes,
  className,
}) {
  const isMobile = useMobileLayout();

  const [isOpen, setIsOpen] = useState(false);

  const closeDrawer = () => setIsOpen(false);
  const openDrawer = () => setIsOpen(true);

  return (
    <div className={classNames(classes.root, className)}>
      <Button endIcon={<HelpIcon />} className={classes.label} onClick={openDrawer}>{label}</Button>
      <Dialog
        anchor="bottom"
        open={isOpen}
        onClose={closeDrawer}
        fullScreen={isMobile}
        TransitionComponent={Transition}
      >
        <div className={classNames(classes.overlayContentTitle, isMobile && classes.overlayContentTitleMobile)}>
          <Typography className={classes.overlayContentTitleText}>{title}</Typography>
        </div>
        <DialogContent className={classNames(classes.overlayContent, isMobile && classes.overlayContentMobile)}>
          {overlayContent}
        </DialogContent>
      </Dialog>
    </div>
  );
}
MoreInfoOverlay.propTypes = {
  title: PropTypes.string,
  label: PropTypes.string,
  overlayContent: PropTypes.object.isRequired,
  classes: PropTypes.object,
  className: PropTypes.object,
};
MoreInfoOverlay.defaultProps = {
  title: '',
  label: 'What does this mean',
  classes: undefined,
  className: undefined,
};

export default withStyles(styles)(MoreInfoOverlay);
